<template>
  <div class="viewport viewport-with-top-nav viewport-compact">

    <TopNav></TopNav>

    <div class="display-1 py-3">{{ $t('LoanClosureConfirmationPage.title') }}</div>
    <div v-if="loan == null" class="pt-4 mt-2">
      <div class="card card-shadow card-rounded border-0 mb-4">
        <div class="card-body py-5 text-center">
          <spinner></spinner>
        </div>
      </div>
    </div>
    <template v-else>
      <div class="row">
        <div class="col-6 form-group">
          <div class="small text-muted">{{ $t('LoanClosureConfirmationPage.reference') }}</div>
          <strong>{{loan.reference}}</strong>
        </div>
        <div class="col-6 form-group">
          <div class="small text-muted">{{ $t('LoanClosureConfirmationPage.loanEndDate') }}</div>
          <strong>{{ $d(loan.endDate) }}</strong>
        </div>
      </div>
      <SendDocumentForm :reference="loan.reference" type="closure"/>
    </template>

    <div class="flex-grow-1"></div>
  </div>
</template>

<script>
    import TopNav from '@shared/components/TopNav'
    import SendDocumentForm from '@shared/components/SendDocumentForm'

    export default {
    name: 'LoanClosureConfirmationPage',
    components: {
      TopNav,
      SendDocumentForm
    },
    data () {
      return {
        loan: null
      }
    },
    created () {
      this.loanId = this.$route.params.id
      this.getLoanById(this.loanId)
    },
    methods: {
      getLoanById(loanId) {
        this.$http.get(`/api/loans/${loanId}/`).then(response => {
          this.loan = response.data.loan
        })
      }
    }
  }
</script>
